'use strict';

// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// You must register a React component here before calling
// render_react_component in PHP
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

module.exports = {

  /**
  * common components used between HS and HF
  */

  Button: require('common/components/button'),
  ButtonTextSubmit: require('common/components/button-text-submit'),
  Input: require('common/components/input'),
  FillEmptySpace: require('common/components/fill-empty-space'),
  PeekABoo: require('common/components/peekaboo'),
  DropDownMenu: require('common/components/drop-down-menu'),
  MobileLinkSubmit: require('common/components/mobile-link-submit'),
  Notification: require('common/components/notifications/index'),
  CloseFancyBoxButton: require('common/components/close-fancy-box-button'),
  IntegrationActivationButton: require('common/components/integration-activation-button'),
  Banner: require('common/components/banner'),
  Tooltip: require('common/components/tooltip'),
  FixedModal: require('common/components/fixed-modal'),
  SimpleGrayLayout: require('common/components/simple-gray-layout'),

  /**
   * HS
   */

  AppTopBar: require('./app/header'),
  AppLeftMenu: require('./app/sidebar'),
  AppFooter: require('./app/footer'),
  HSTeamPage: require('./app/content/team'),

  TwoOptionTabPane: require('./api/two-option-tab-pane'),
  StandardTabPane: require('./api/standard-tab-pane'),

  ApiMenu: require('./api-docs/api-menu'),
  CodeTabPane: require('./api-docs/code-tab-pane'),
  CodeTabPaneWithResponse: require('./api-docs/code-tab-pane-with-response'),
  ImageModalTrigger: require('./api-docs/image-modal-trigger'),

  CreateAccount: require('./auth/create-account'),
  LogInVerificationForm: require('./auth/login-verification-form'),
  LogInModal: require('./auth/login-modal'),
  CreateAccountTrigger: require('./auth/create-account-trigger'),
  LogInTrigger: require('./auth/login-trigger'),
  GoogleLoginOrSignup: require('./auth/google-login-or-signup'),
  LogInForm: require('./auth/login-form'),
  VerifyEmail: require('./auth/verify-email'),
  LogInInPerson: require('./auth/login-in-person'),
  SignUpPage: require('./auth/sign-up-page'),
  RecoverPasswordPage: require('./auth/recover-password-page'),
  LogInPage: require('./auth/log-in-page'),
  LogInCaptcha: require('./auth/login-captcha'),

  HomePageSignup: require('./home/signup'),
  HomePageManualSignup: require('./home/manual-signup'),
  TopBarMenu: require('./home/top-bar-menu'),
  TopBarMenuLink: require('./home/top-bar-menu/top-bar-menu-link'),
  LogInButton: require('./home/top-bar-menu/login-button'),
  SignUpButton: require('./home/top-bar-menu/signup-button'),
  CancelSubscriptionPage: require('./home/cancel-subscription/cancel-subscription-page'),
  CustomerCancelOffer: require('./pricing/customer-cancel-offer'),
  BlackBarAnnouncements: require('./home/black-bar-announcements'),

  PricingArea: require('./pricing'),
  PaymentModal: require('./pricing/payment-modal'),
  PaymentPage: require('./pricing/payment-page'),
  EnterpriseAgreement: require('./pricing/enterprise-agreement'),
  TabbedArea: require('./tabbed-area'),
  MarketoForm: require('./marketo-form'),

  ChooseSignupPlan: require('./pricing/choose-signup-plan'),
  CollectInfo: require('./home/collect-info'),
  TeamReporting: require('../team-reporting')['default'],
  DownloadPage: require('../../ui/download-page')['default'],

  /**
   * HF
   */

  FaxLineConfigList: require('./app/content/team/team-fax-lines'),

  /**
   * Landing Pages
   */
  ESignatureFree: require('landing-pages/components/seo/e-signature-free'),
  AutomatePaperwork: require('landing-pages/components/seo/automate-paperwork'),
  AutomateWorkflow: require('landing-pages/components/seo/automate-workflow'),
  OnlineDigitalSignatures: require('landing-pages/components/seo/online-digital-signatures'),
  OnlineContract: require('landing-pages/components/seo/online-contract'),
  FreeEsignatureTool: require('landing-pages/components/seo/free-esignature-tool'),
  SignDocumentsElectronically: require('landing-pages/components/seo/sign-documents-electronically'),
  HowCreateElectronicSignature: require('landing-pages/components/seo/how-create-electronic-signature'),
  HowToSignOnline: require('landing-pages/components/seo/how-to-sign-online'),
  OnlineSignatureApp: require('landing-pages/components/seo/online-signature-app'),
  ElectronicSignature: require('landing-pages/components/seo/electronic-signature'),
  DigitalSignature: require('landing-pages/components/seo/digital-signature'),
  ESignaturesSEO: require('landing-pages/components/seo/esignatures'),
  ESignSEO: require('landing-pages/components/seo/esign'),
  PDFESignatureSEO: require('landing-pages/components/seo/pdf-esignature'),
  Dropbox: require('landing-pages/components/seo/dropbox'),
  Box: require('landing-pages/components/seo/box'),
  Evernote: require('landing-pages/components/seo/evernote'),
  OneDrive: require('landing-pages/components/seo/onedrive'),
  EventbriteLandingPage: require('landing-pages/components/seo/eventbrite-landing-page'),
  WhiteLabelingLandingPage: require('landing-pages/components/seo/white-labeling'),
  HubSpotCRMLandingPage: require('landing-pages/components/seo/hubspot-crm-landing-page'),
  DocusignSwitch: require('landing-pages/components/docusign-switch'),
  CareersPage: require('landing-pages/components/careers-page'),
  Integrations: require('landing-pages/components/integrations'),
  Salesforce: require('landing-pages/components/seo/salesforce'),
  Oracle: require('landing-pages/components/seo/oracle'),
  RealEstate: require('landing-pages/components/seo/real-estate'),
  Slack: require('landing-pages/components/seo/slack'),
  Gmail: require('landing-pages/components/seo/gmail'),
  GoogleDrive: require('landing-pages/components/seo/google-drive'),
  GoogleDocs: require('landing-pages/components/seo/google-docs')
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/index.js
 ** module id = 695
 ** module chunks = 0
 **/